// Plan 1a Welle 2 (SPEC-ADMIN.md „Aus Ä-26 und Ä-32 vorgezogen“ Stück 3, P1-37; welle-2/admin/AUFTEILUNG.md 3.2): die zehn
// Anker der Seite „Rechnungen und Vertrag“ (BillingPanel.tsx), in der Reihenfolge der Seite. Ohne React und ohne weitere
// Einbindungen, damit die Suche (seiten.ts), die Einrichtungsliste, „Firmendaten“ und die Mitgliederliste sie benutzen können,
// ohne die Abrechnung zu laden. Jeder Abschnitt trägt seinen Anker als id; „Rechnungsprofil“ an beiden Fassungen (lesend und
// mit Formular). Gesprungen wird über useAnkerSprung, sobald Abo und Profil geladen sind; der Sprungabstand (72 px, die Höhe
// des Seitenkopfs) steht an der Klasse einst-abr-anker in einst-tarif.css.
export const ABRECHNUNG_ANKER = {
  abonnement: 'abonnement',
  offeneZahlungsauftraege: 'offene-zahlungsauftraege',
  rechnungen: 'rechnungen',
  rechnungsprofil: 'rechnungsprofil',
  vertragsbedingungen: 'vertragsbedingungen',
  // Profil-Nachbau F-16 (BAU-RECHT.md 2.2, PF-781): der AVV-Abschnitt des Einzelkontos; die Firma hat die Seite „Verträge & AVV“.
  avv: 'avv',
  tarifWechseln: 'tarif-wechseln',
  datenExportieren: 'daten-exportieren',
  vertragUebergeben: 'vertrag-uebergeben',
  vertragBeenden: 'vertrag-beenden',
} as const;
export type AbrechnungAnker = typeof ABRECHNUNG_ANKER[keyof typeof ABRECHNUNG_ANKER];

// Plan 1a Welle 2 (vorgezogen 3, P1-37; P2-26): „Auf dieser Seite“ ist der sichtbare Vorsatz einer Sprungzeile und der Name der
// Zeile für Vorlesehilfen. F-24 (PF-TX-geld-3, E-2, FRAGEN F-24-geld-2): „Rechnungen und Vertrag“ hat keine Sprungzeile mehr
// (meinGPT hat keine); sprungZiele und SprungLage sind mit ihr entfallen, die Anker oben bleiben. Den Namen benutzt weiter die
// Sprungzeile von „Kontingent“ (CostPanel.tsx, kontingentSprung.ts).
export const SPRUNGZEILE_NAME = 'Auf dieser Seite';
